import { Component, Prop } from 'vue-property-decorator';
import { Block } from '../../../helpers/components';
import { BaseBlock } from '../../base-block';
import { EquipmentSelectionType } from '@/enums/EquipmentSelectionType';
import { ApartmentDTO } from '../../../model/ApartmentDTO';

import { sortBy, intersection } from 'lodash-es';

@Block() @Component
export class ApartmentSpecialEquipmentBlock extends BaseBlock {
	@Prop() apartment: ApartmentDTO;

	expand: boolean = false;

	get specialEquipmentDescriptions() {
		return sortBy(this.apartment.specialEquipmentDescriptions, ['order']);
	}

	get showFloorsAndDoorsSelectionText() {
		return intersection(this.apartment.equipmentSelections.filter(es => es.selectionDate).map(es => es.type), [EquipmentSelectionType.Floors, EquipmentSelectionType.InnerDoors]).length == 0
			&& this.apartment.clientChangesDeadlines[2] /* termin3 */ != null && new Date(this.apartment.clientChangesDeadlines[2]) < new Date();
	}

	get webNote() {
		return (this.apartment.webNote || '').trim();
	}

}

export default ApartmentSpecialEquipmentBlock;
